import { render } from "./AdminTrips.vue?vue&type=template&id=7e8aa4dc&scoped=true"
import script from "./AdminTrips.vue?vue&type=script&lang=js"
export * from "./AdminTrips.vue?vue&type=script&lang=js"

import "./AdminTrips.vue?vue&type=style&index=0&id=7e8aa4dc&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8aa4dc"]])

export default __exports__